import React from "react";
import classNames from "utilities/ClassNames";
import { BorderGradientProps } from "./domain/types";

const BorderGradient: React.FC<BorderGradientProps> = ({ className = '', children, noBorder = false }) => {
  return (
    <>
      {noBorder ? (
        <div className={classNames(className, 'p-[1px] overflow-hidden')}>
          {children}
        </div>
      ) : (
        <div className={classNames(className, 'gradient p-[1px] rounded-lg overflow-hidden')}>
          {children}
        </div>
      )}
    </>
  );
};

export default BorderGradient;